import React from 'react';
/**
 * @function pack
 * @since 1.0.0
 * @hidden
 */
export function pack(children) {
    const values = {};
    React.Children.forEach(children, (child) => {
        if (values[child.key] == null) {
            values[child.key] = child;
        }
    });
    return values;
}
